'use client';

import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import CustomButton from "../common/buttons/button";
import Send from '@/assets/svg/icons/send.svg';
import { useMobileApp } from "@/providers/mobile-app-context";
import { usePublicProviderInteraction } from "./public_provider_interaction_context";
import classes from "./public_provider_sticky_cta.module.css";

// native-app-only floating CTA bar; portaled to <body> since `position: fixed` breaks
// (behaves like `absolute`) inside the native page-transition wrapper, which applies a CSS transform
export default function PublicProviderStickyCta() {
    const { isNativeApp } = useMobileApp();
    const { openContactMobile } = usePublicProviderInteraction();
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    if (!isNativeApp || !mounted) return null;

    return createPortal(
        <div className={classes["sticky-cta-bar"]}>
            <CustomButton className="w-100" size="lg" hierarchy="primary" icon="leading" is_svg={true} svg={Send} onClick={openContactMobile}>
                Ajánlatkérés
            </CustomButton>
        </div>,
        document.body
    );
}
